import cx from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Progress, Statistic } from 'semantic-ui-react';

import { bem } from '../../core/design/bem';

const css = bem('GroupQuotaHeader');
const translationPrefix = 'group-visits';

type GroupQuotaHeaderProps = {
  /** Nombre de groupes déjà créés par l'utilisateur */
  groupCount: number;
  /** Nombre maximum de groupes autorisés (config `groupQuota`) */
  quota: number;
};

const GroupQuotaHeader = ({ groupCount, quota }: GroupQuotaHeaderProps): JSX.Element => {
  const { t } = useTranslation();
  const percent = quota > 0 ? Math.min(100, Math.round((groupCount / quota) * 100)) : 0;
  const isFull = groupCount >= quota;

  return (
    <div className={cx(css({ full: isFull }).toString())}>
      <Statistic size="small" className={css('stat').toString()}>
        <Statistic.Value>
          {groupCount} / {quota}
        </Statistic.Value>
        <Statistic.Label>{t(`${translationPrefix}.quota.label`)}</Statistic.Label>
      </Statistic>
      <Progress
        className={css('progress').toString()}
        percent={percent}
        size="small"
        color={isFull ? 'red' : 'green'}
      >
        {t(`${translationPrefix}.quota.fill-rate`, { percent })}
      </Progress>
    </div>
  );
};

export default GroupQuotaHeader;
